import { Link } from 'react-router-dom';

const steps = [
  {
    num: '01',
    icon: 'ri-coupon-3-line',
    title: '挑一场瓜局',
    text: '从追更大厅按类型或热度挑选感兴趣的系列，竞演、情感、影视、商业……想吃哪口翻哪页。',
  },
  {
    num: '02',
    icon: 'ri-tv-2-line',
    title: '按集追更',
    text: '每个瓜局都按 第1集、第2集……第N集 的时间线完整整理，随时回看前因后果，不再断片。',
  },
  {
    num: '03',
    icon: 'ri-alarm-line',
    title: '蹲守后续',
    text: '剧情更新、后续进展第一时间同步，关键反转不错过。想追的系列，翻着翻着就上瘾。',
  },
];

export default function Guide() {
  return (
    <>
      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto w-full px-4 md:px-6">
          <div className="mx-auto w-full max-w-6xl">
            <div className="text-center">
              <p className="text-sm font-bold tracking-wide text-primary-600">吃瓜三步走</p>
              <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-4xl">怎么追更一部瓜局连续剧</h2>
              <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
                把零散瓜料变成能追下去的连续剧，只需简单三步。
              </p>
            </div>

            <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
              {steps.map((s) => (
                <div
                  key={s.num}
                  className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7"
                >
                  <span className="absolute -right-1 -top-4 font-heading text-7xl text-primary-100 md:text-8xl">
                    {s.num}
                  </span>
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-500 text-2xl text-background-50">
                    <i className={s.icon}></i>
                  </span>
                  <h3 className="relative mt-4 text-lg font-bold text-foreground-950">{s.title}</h3>
                  <p className="relative mt-2 text-sm leading-6 text-foreground-600">{s.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto w-full max-w-6xl">
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-primary-600 via-primary-500 to-secondary-400 p-8 md:p-14">
            <div className="pointer-events-none absolute -right-10 -top-12 h-48 w-48 rounded-full bg-background-50/15"></div>
            <div className="pointer-events-none absolute -bottom-16 right-24 h-40 w-40 rounded-full bg-accent-400/30"></div>
            <div className="relative flex flex-col items-center justify-between gap-6 text-center lg:flex-row lg:text-left">
              <div>
                <h2 className="font-heading text-2xl leading-snug text-background-50 md:text-4xl">
                  这一场瓜局，你翻页了吗？
                </h2>
                <p className="mt-2 text-sm text-background-100/90 md:text-base">
                  剧情更新、后续进展、系列跟踪，都在追更大厅等着你。现在就开始，别错过下一集的爆点。
                </p>
              </div>
              <Link
                to="/chasing"
                className="flex h-12 shrink-0 items-center whitespace-nowrap rounded-full bg-background-50 px-8 text-base font-bold text-primary-700 transition-transform hover:-translate-y-0.5"
              >
                去追更大厅
                <i className="ri-arrow-right-up-line ml-2 text-lg"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}